<template>
  <div class="call-box">
    <div class="call-info" v-show="isCalling">
      <Spin :spinning="callInfoLoading">
        <div class="item">
          <span class="label">关联单号：</span>
          <span :class="[isAllowJump? 'value' : 'text']"
            @click="toNumberDetail"
          >
            {{ callInfo.businessId || '--' }}
          </span>
        </div>
        <div class="item">
          <span class="label">联系人：</span>
          <span class="text">
            {{ callInfo.customerName || '未知联系人' }}
            （{{ customerTypeMap[callInfo.customerType] || '--' }}）
          </span>
        </div>
      </Spin>
    </div>
    <div id="call-box"></div>
    <Dropdown class="call-custom"
      :disabled="!isCalling"
      :visible="dialogVisible"
      :trigger="['click']"
      placement="bottomLeft"
      :overlayStyle="{zIndex:99999}"
    >
      <Button @click="setDialogVisible">
        <span class="icon"></span>
        通话总结
      </Button>
      <template #overlay>
        <CallSumUp
          :callID="callID"
          :dialogVisible.sync="dialogVisible"
          :businessInfo="businessInfo"
          :isCalling="isCalling"
        />
      </template>
    </Dropdown>
  </div>
</template>
<script>
import mainBus from '@/micro/eventBus';
import dayjs from 'dayjs';
import md5 from 'js-md5';
import axios from 'axios';
import {
  Button, Dropdown, Spin, message,
} from 'ant-design-vue';
import { get, post } from '@/utils/http';
import api from '@/api';
import CallSumUp from './CallSumUp.vue';
import { CustomerTypeMap } from './types.ts';

export default {
  name: 'CallBox',
  components: {
    Button, Dropdown, CallSumUp, Spin,
  },
  data: () => ({
    dialogVisible: false,
    isCalling: false,
    businessInfo: {},
    callInfoLoading: true,
    callInfo: {},
    customerTypeMap: CustomerTypeMap,
    /* 座席外显中继号码 */
    gatewayNumber: '',
    /* 所属部门 */
    orgType: null,
    /* 是否弹起通话总结 */
    isOpenSumUp: true,
    /* 发送短信需要的参数 */
    callBusinessId: '',
    callID: '',
    callBackCode: [],
    isLock: false,
    /* 是否接听电话(0:是,1:否) */
    resultFlag: 1,
  }),
  computed: {
    /* 单号是否能跳转 */
    isAllowJump() {
      return [2, 8, 9].includes(this.businessInfo.businessType) && this.callInfo?.businessId;
    },
  },
  created() {
    this.call();
    this.getCallBackCodeMap();
    mainBus.$on('call-number', (businessInfo) => {
      if (!this.isLock) {
        this.isOpenSumUp = businessInfo.isOpenSumUp !== 0;
        this.businessInfo = businessInfo || {};
        if (window?.sobotAgent?.makeCall) {
          window.sobotAgent.makeCall({
            otherDN: businessInfo.customerPhone,
          });
        }
        this.isLock = true;
        setTimeout(() => {
          this.isLock = false;
        }, 500);
      } else {
        message.warning('请勿重复点击');
        setTimeout(() => {
          this.isLock = false;
        }, 500);
      }
    });
  },
  methods: {
    /* 通话业务单据保存 */
    async apiCallBusinessId(customerPhone, callId, messageID) {
      const params = messageID === 'EventDialing' ? this.businessInfo : this.callInfo;
      const info = await post(api.businessInsert, {
        ...params,
        callId,
        customerPhone,
      });
      this.callBusinessId = info?.callBusinessId;
      this.businessInfo = info;
      this.sumUpOpen(callId);
      if (messageID === 'EventDialing') {
        this.getCallInfo(customerPhone, callId, messageID);
      }
    },
    /* 点击单号 */
    toNumberDetail() {
      switch (this.businessInfo.businessType) {
        case 2:
          /* 跳转商机详情 */
          this.$router.push({
            path: `/dispatch/opportunity/${this.businessInfo?.businessId}`,
          });
          break;
        case 8:
          /* 跳转居间订单详情 */
          this.$router.push({
            path: '/goodManager/orderDetail',
            query: { tradeId: this.businessInfo?.businessId },
          });
          break;
        case 9:
          /* 跳转联营订单详情 */
          this.$router.push({
            path: '/goodManager/jointOrderDetail',
            query: { tradeId: this.businessInfo?.businessId },
          });
          break;
        default:
          break;
      }
    },
    /* 来电/拨打：获取联系人信息 */
    getCallInfo(customerPhone, callId, messageID) {
      post(api.queryContactCard, { customerPhone }).then((res) => {
        this.callInfo = res || {};
      }).catch(() => {
        this.callInfo = {};
      }).finally(() => {
        this.callInfoLoading = false;
        if (messageID === 'EventRinging') {
          this.apiCallBusinessId(customerPhone, callId, messageID);
        }
      });
    },
    /* 发送短信 */
    sendCallOutMessage() {
      if (this.callBusinessId) {
        post(api.sendCallOutMessage, {
          callBusinessId: this.callBusinessId,
          gatewayNumber: this.gatewayNumber,
        }).finally(() => {
          this.callBusinessId = '';
        });
      } else {
        setTimeout(() => {
          this.sendCallOutMessage();
        }, 1000);
      }
    },
    /* 弹起通话总结弹窗 */
    sumUpOpen(callId) {
      /* 交付部门不弹/一键外呼时有不允许弹传参数 */
      if (this.orgType === 2 || !this.isOpenSumUp) return;
      if (this.dialogVisible) {
        this.callID = callId;
      } else {
        this.dialogVisible = true;
      }
    },
    callEvent(data) {
      const {
        messageID, errorMessage, otherDN, callID, callType,
      } = data;
      this.gatewayNumber = data.attachedData.to_customer_ani;
      if (messageID === 'EventDialing') {
        console.log('拨打 || 被呼叫响铃声', data);
        /* 拨打 || 被呼叫响铃声 */
        this.callInfoLoading = true;
        this.isCalling = true;
        this.resultFlag = 1;
        this.apiCallBusinessId(otherDN, callID, messageID);
      } else if (messageID === 'EventRinging') {
        console.log('呼入响铃', data);
        /* 呼入响铃 */
        this.isCalling = true;
        this.callInfoLoading = true;
        this.getCallInfo(otherDN, callID, messageID);
      } else if (messageID === 'EventEstablished') {
        console.log('接通电话', data);
        this.resultFlag = 0;
      } else if (messageID === 'EventReleased') {
        console.log('挂断', data);
        /* 挂断 */
        this.isCalling = false;
        this.businessInfo = {};
        this.callInfo = {};
        /* 未正常接通回铃音保存 */
        if (this.resultFlag === 1) {
          this.recordCallErrorSave(data);
        }
        /* 呼出电话挂断后发送短信 */
        if (callType === 'Outbound') {
          this.debounce(this.callLogSave(data));
          this.sendCallOutMessage();
        } else {
          this.resultFlag = 1;
        }
      } else if (['EventPartyError', 'EventAgentError'].includes(messageID)) {
        let env = window.localStorage.getItem('znEnv');
        env = env === 'product' ? 'prd' : env;
        /* 错误监控上报 */
        axios.post('http://cmdb.linggekj.org/api/alert/alert-alarm/application/', {
          summary: '呼叫中心-测试飞书告警',
          detail: errorMessage,
          env,
          platform: env,
          service_name: 'call-center',
          level: 'High',
        });
      }
    },
    setDialogVisible() {
      this.dialogVisible = !this.dialogVisible;
    },
    init(accessToken, agentid, companyId) {
      if (window.sobotAgent) {
        window.sobotAgent.initTelBar({
          id: 'call-box',
          token: accessToken,
          companyId,
          agent: agentid,
          agentType: '1',
          themeColor: {
            showLeftLine: true,
            showRightLine: true,
            light: '#ffffff',
            dark: '#515A7C',
            darkContent: '#434A66',
          },
          appConfig: {
            placement: 'right',
            showQueueInfo: true,
            showNetDelayInfo: true,
          },
          actionConfig: {
            transfer: true,
            consult: true,
            keepContinue: true,
            stillVoice: true,
            sendSatisfaction: true,
            extendBtn: true,
            internal: true,
            extendFinishTime: 60,
          },
          settingConfig: {
            readOnlyExt: false,
            showUnbind: true,
          },
        },
        (res) => {
          this.callEvent(res);
        });
        // window.sobotAgent.doLogin();
      } else {
        setTimeout(() => {
          this.init(accessToken, agentid, companyId);
        }, 1000);
      }
    },
    async call() {
      const currentTime = dayjs().valueOf();
      try {
        const agentInfo = await get(api.agentInfo);
        this.orgType = agentInfo?.orgType;
        if (agentInfo?.agentId) {
          const tokenInfo = await axios.post('https://openapi.soboten.com/tokens/agent', {
            responseType: 'token',
            appId: agentInfo.appId,
            agentId: agentInfo.agentId,
            currentTime,
            sign: md5(`${agentInfo.appId}${currentTime}token${agentInfo.appKey}`),
          });
          localStorage.setItem('call-accessToken', tokenInfo?.data?.accessToken);
          this.init(tokenInfo.data.accessToken, agentInfo.agentId, agentInfo.companyId);
        } else {
          localStorage.removeItem('call-accessToken');
        }
      } catch (e) {
        console.log(e);
      }
    },
    callLogSave(data) {
      console.log('呼出的电话');
      post(api.callLogSave, {
        caller: localStorage.getItem('name') || '灵播管家',
        mobileOriginatingCall: data.attachedData.to_customer_ani,
        mobileTerminatingCall: data.otherDN,
        resultFlag: this.resultFlag,
      }).finally(() => {
        this.resultFlag = 1;
      });
    },
    recordCallErrorSave(data) {
      console.log('-----未正常接听电话', this.callBackCode, data.earlyDetectCause);
      const callErrorObj = this.callBackCode.find((item) => item.value === String(data.earlyDetectCause));
      if (callErrorObj) {
        post(api.recordCallError, {
          callErrorCode: data.earlyDetectCause,
          callErrorCodeDesc: callErrorObj?.description || '',
          callId: data.callID,
        }).then(() => { });
      }
    },
    getCallBackCodeMap() {
      const key = 'N01_CALL_BACK_CODE';
      get(api.dictionaryTableObject, { key }).then((res) => {
        this.callBackCode = res?.sonDictionaries || [];
      });
    },
    // 防抖的封装
    debounce(fn, delay = 500) { // fn要执行的方法 delay时间默认是500
      let timer;
      return function () {
        const self = this;// 拿到this vue中使用指向vue
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;// 获取参数
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn.apply(self, args);
        }, delay);
      };
    },
  },
};
</script>
<style lang="less" scoped>
.call-box {
  display: flex;
  height: 42px;
  z-index: 100;
  .call-info {
    padding: 4px 10px;
    background: #ECF5FF;
    border-radius: 2px;
    margin-right: 6px;
    /deep/ .ant-spin-blur {
      opacity: .1;
    }
    .item {
      display: flex;
      font-size: 12px;
      .label {
        width: 60px;
        color: #666;
      }
      .value {
        color: #3673FF;
        cursor: pointer;
      }
      .text {
        color: #666;
      }
    }
  }
  .ant-btn {
    background-color: #fff;
    border: none;
    box-shadow: none;
    margin-top: 5px;
    display: flex;
    flex-direction: row;
    align-items: center;
    &[disabled='disabled'] {
      .icon {
        background-image: url('~@/assets/images/file_edit_disabled.png');
      }
    }
    .icon {
      background-image: url('~@/assets/images/file_edit.png');
    }
  }
  .icon {
    width: 20px;
    height: 20px;
    background-size: 100%;
    margin-right: 2px;
  }
}
</style>
